import { useState } from "react";
import { useRecoilValue } from "recoil";
import classNames from "classnames";
import { menuState } from "@/comn/features/recoil";
import { useAuth } from "@/comn/hooks";

import { Dev_NavigationTabMenu } from "./Dev_NavigationTabMenu";
import { NavigationTabMenu } from "./NavigationTabMenu";
import { NavigationTabBookmark } from "./NavigationTabBookmark";

export const NavigationTab = () => {
    const { isSignedIn } = useAuth();
    const { isDev } = useRecoilValue(menuState);
    const [type, setType] = useState("menu");

    /** */
    const Button = ({ children, disabled, t }: any) => {
        return (
            <button
                aria-selected={t === type}
                disabled={disabled}
                onClick={() => {
                    if (!disabled) {
                        setType(t);
                    }
                }}
                className={classNames(
                    "flex-1 bg-header text-darkgray rounded-t font-semibold",
                    "dark:bg-background dark:text-lightgray",
                    "aria-selected:bg-primary aria-selected:text-primary-contrast dark:aria-selected:bg-primary dark:aria-selected:text-primary-contrast",
                    "disabled:bg-lightgray dark:disabled:bg-gray",
                )}
            >
                {children}
            </button>
        );
    };

    return (
        <div className="h-[calc(100%-340px)] flex flex-col">
            <div className="flex h-8 px-4 gap-2">
                <Button t="menu">Menu</Button>
                <Button t="bookmark" disabled={!isSignedIn}>
                    Bookmark
                </Button>
            </div>

            <div className="relative flex-1 overflow-y-auto overflow-x-hidden">
                <div className="absolute w-[280px] py-4 left-0 top-0">
                    {(() => {
                        switch (type) {
                            case "menu":
                                return isDev ? <Dev_NavigationTabMenu /> : <NavigationTabMenu />;
                            case "bookmark":
                                return <NavigationTabBookmark />;
                            default:
                                return null;
                        }
                    })()}
                </div>
            </div>
        </div>
    );
};
